import React from "react";
import { useNavigate } from "@tanstack/react-router";
import styles from "./selectGame.module.css";
import { GameSelectShopCard } from "@shared/ui/gameSelectShopCard/ui/gameSelectShopCard";

export const SelectGameShop: React.FC = () => {
  const navigate = useNavigate();

  const handleGameSelect = (game: string) => {
    if (game === "CSGO") {
      navigate({ to: "/shop/select-game/top-skins" });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.fixedSizeContainer}>
        <div className={styles.gamesContainer}>
          <GameSelectShopCard
            game="CSGO"
            onClick={() => handleGameSelect("CSGO")}
          />
          <GameSelectShopCard game="DOTA2" />
          <GameSelectShopCard game="MARVEL" />
          <GameSelectShopCard game="PUBG" />
        </div>
      </div>
    </div>
  );
};
